export default "__VITE_ASSET__fNF7tvfw__"